/* eslint-disable no-restricted-imports */

/*
 * !!! If you are adding new variant here RECONSIDER. Variants make sense only if MUI props are used. If you
 * are using O2 props for style changes you have to rework it to Styled*** component and remove those variant because O2
 * will bubble to DOM otherwise.
 */
import button from '../Button/variants';
import chip from '../Chip/variants';
import formControlLabel from '../FormControlLabel/variants';
import iconButton from '../IconButton/variants';
import radio from '../Radio/variants';
import step from '../Step/variants';
import switch_ from '../Switch/variants'; // "switch" is reserved JS word
import tab from '../Tab/variants';
import tableRow from '../TableRow/variants';
import tabs from '../Tabs/variants';
import pane from '../Pane/variants';
import dialogActions from '../DialogActions/variants';
import link from '../Link/variants';
import listItem from '../ListItem/variants';
import listItemIcon from '../ListItemIcon/variants';
import listItemText from '../ListItemText/variants';
import container from '../Container/variants';
import toggleButton from '../ToggleButton/variants';
import toggleButtonGroup from '../ToggleButtonGroup/variants';
import typography from '../Typography/variants';
import productCard from '../ProductCard/variants';

const variants = {
  button,
  chip,
  container,
  dialogActions,
  formControlLabel,
  iconButton,
  link,
  listItem,
  listItemIcon,
  listItemText,
  pane,
  productCard,
  radio,
  step,
  switch_,
  tab,
  tableRow,
  tabs,
  toggleButton,
  toggleButtonGroup,
  typography,
};

export default variants;
